import React, { Component } from 'react'
import Popover from '../../../components/uielements/popover'
import { connect } from 'react-redux'
import IntlMessages from '../../../components/utility/intlMessages'
import TopbarDropdownWrapper from './topbarDropDown.style'
import { FaBell } from 'react-icons/fa'
import NotifyAction from '../../../redux/Notify/actions'
import { NotifyItem, NotifyText, Header } from './topbar.style'
import { Avatar } from 'antd'
import moment from 'moment'
import { withRouter } from 'react-router-dom'
import drawerActions from '../../../redux/drawer/actions'
import { Scrollbars } from 'react-custom-scrollbars'

class TopbarNotification extends Component {
    constructor(props) {
        super(props)
        this.handleVisibleChange = this.handleVisibleChange.bind(this)
        this.hide = this.hide.bind(this)
        this.state = {
            visible: false,
        }
    }
    componentDidMount() {
        const { getListNotify } = this.props
        const isRefresh = true
        getListNotify(1, 10, isRefresh)
        this._interval = setInterval(() => {
            getListNotify(1, 10, isRefresh)
        }, 180000)
    }
    getNotifyUnread = () => {
        const { notify } = this.props
        let number = 0
        notify.map(e => {
            if (!e.is_read) {
                number = number + 1
            }
        })
        return number
    }
    hide() {
        this.setState({ visible: false })
    }
    handleVisibleChange() {
        this.setState({ visible: !this.state.visible })
        const { getListNotify } = this.props
        const isRefresh = true
        getListNotify(1, 10, isRefresh)
    }
    getTime = time => {
        const tm = moment().unix() - time
        if (tm < 3600) {
            return (tm / 60) >> 0
        }
        if (tm < 86400) {
            return (tm / 3600) >> 0
        }
        if (tm > 86400) {
            return (tm / 86400) >> 0
        }
    }
    clickLoadMore = () => {
        const { getListNotify, pageIndex } = this.props
        getListNotify(pageIndex + 1, 10)
        console.log('load more')
    }
    getUnitTime = time => {
        const tm = moment().unix() - time
        if (tm < 3600) {
            return 'm'
        }
        if (tm < 86400) {
            return 'h'
        }
        if (tm > 86400) {
            return 'd'
        }
    }
    setReadall = () => {
        this.props.setReadAllAPI()
    }
    _onClickNotify = notify => {
        console.log('notify click', notify)
        if (!notify.is_read) {
            this.props.setReadNotify(notify.notify_id)
        }

        this.setState({ visible: false })
        //open notify multiflow
        if (notify.type === 'Report_Regularly') {
            this.props.history.push(`/app/qbreport/${notify.id_type}`)
        }
        if(notify.type === 'Comment_Report_Regularly'){
            this.props.history.push(`/app/qbreport/${notify.ext_data.report_id}`)
        }
        //open notify message
        if (notify.type === 'Comment_Message') {
            this.props.history.push(`/app/message/${notify.ext_data.messid}`)
        }
        if (notify.type === 'Report_Message') {
            this.props.history.push(`/app/message/${notify.id_type}`)
        }
        // Open notify report
        if (notify.type === 'Report') {
            this.props.history.push(
                `/app/qbtask/project/${notify.ext_data.task_id}`
            )
            this.props.getDataTaskInNotify(
                notify.id_type,
                notify.ext_data.task_id
            )
        }
        // open notify task
        if (notify.type === 'Task') {
            this.props.history.push(
                `/app/qbtask/project/${notify.ext_data.task_id}`
            )
        }
        // open notify for comment in report of task
        if (notify.type === 'Comment_Report') {
            this.props.history.push(
                `/app/qbtask/project/${notify.ext_data.task_id}`
            )
            this.props.getDataTaskInNotify(
                notify.ext_data.report_id,
                notify.ext_data.task_id
            )
        }
    }

    render() {
        const { notify } = this.props
        console.log('notify data', notify)
        const content = (
            <TopbarDropdownWrapper className="topbarNotification">
                {/* <div className="isoDropdownHeader">
                    <h3>
                        <IntlMessages id="topbar.notification" />
                    </h3>
                </div> */}
                <Header
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <text style={{ color: 'black', fontWeight: '500' }}>
                        Thông báo
                    </text>
                    <a
                        style={{
                            color: '#4267b2',
                            fontWeight: '400',
                            paddingRight: 4,
                            fontSize: 13,
                        }}
                        onClick={() => this.setReadall()}
                    >
                        {' '}
                        Đánh dấu tất cả đã đọc
                    </a>
                </Header>
                <Scrollbars
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        height: 400,
                        backgroundColor: 'white',
                    }}
                >
                    {notify.map(notify => (
                        <NotifyItem
                            onClick={() => {
                                this._onClickNotify(notify)
                            }}
                            style={{
                                height: 70,
                                alignItems: 'center',
                                backgroundColor: !notify.is_read
                                    ? '#a2c9aa'
                                    : '#ffffff',
                            }}
                            is_read={notify.is_read}
                        >
                            <Avatar
                                style={{ objectFit: 'cover' }}
                                src={
                                    notify.avatar === ''
                                        ? require('../../../resource/image/logo.jpg')
                                        : notify.avatar
                                }
                            />
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    height: 60,
                                    paddingTop: 5,
                                    paddingLeft: 7,
                                    width: '100%',
                                }}
                            >
                                <NotifyText style={{}}>
                                    <text>
                                        <text
                                            style={{
                                                fontWeight: '500',
                                                color: 'black',
                                            }}
                                        >
                                            {notify.user_action + ' '}
                                        </text>
                                        <text>
                                            {notify.linking_words + ' '}
                                        </text>
                                        <text
                                            style={{
                                                fontWeight: '500',
                                                color: 'black',
                                            }}
                                        >
                                            {notify.action_info + ' '}
                                        </text>
                                    </text>
                                </NotifyText>
                                <text style={{ fontSize: 13 }}>
                                    {moment()
                                        .subtract(
                                            this.getTime(notify.time),
                                            this.getUnitTime(notify.time)
                                        )
                                        .fromNow()}
                                </text>
                            </div>
                        </NotifyItem>
                    ))}
                </Scrollbars>
                <div className="isoViewAllBtn">
                    {this.props.total / 10 > this.props.pageIndex && (
                        <div onClick={() => this.clickLoadMore()}>Xem thêm</div>
                    )}
                    {this.props.total / 10 <= this.props.pageIndex && (
                        <div>Đã hết thông báo</div>
                    )}
                </div>
            </TopbarDropdownWrapper>
        )
        const contentEmpty = (
            <TopbarDropdownWrapper className="topbarNotification">
                <div className="isoDropdownHeader">
                    <h3>
                        <IntlMessages id="topbar.notification" />
                    </h3>
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        minHeight: 200,
                    }}
                >
                    Hiện tại không có thông báo
                </div>
            </TopbarDropdownWrapper>
        )
        return (
            <Popover
                content={notify.length > 0 ? content : contentEmpty}
                trigger="click"
                visible={this.state.visible}
                onVisibleChange={this.handleVisibleChange}
                placement="bottomLeft"
            >
                <div className="isoIconWrapper">
                    <FaBell style={{ fontSize: 24, color: 'white' }} />
                    {this.getNotifyUnread() !== 0 && (
                        <span>{this.getNotifyUnread()}</span>
                    )}
                </div>
            </Popover>
        )
    }
}

const mapStateToProps = state => {
    return {
        notify: state.NotifyReducer.notify,
        pageIndex: state.NotifyReducer.pageIndex,
        total: state.NotifyReducer.total,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getListNotify: (page_size, page_number, isRefresh) => {
            dispatch(
                NotifyAction.action.getListNotify(
                    page_size,
                    page_number,
                    isRefresh
                )
            )
        },
        setReadNotify: id => {
            dispatch(NotifyAction.action.setReadNotify(id))
        },
        openDrawer: payload => {
            dispatch(drawerActions.openDrawer(payload))
        },
        getDataTaskInNotify: (id, idostask) => {
            dispatch(NotifyAction.action.getDataTaskInNotify(id, idostask))
        },
        setReadAllAPI: () => {
            dispatch(NotifyAction.action.setReadAllAPI())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(TopbarNotification))
